import * as React from "react";
import { render } from "../../common/reactUtils";
import { DocumentAccessRightsModal } from "./documentAccessRightsModal";

export const initialize = () =>
  render(<DocumentAccessRightsModal />, "#js-react-document-access-app");
